import { useEffect, useState } from "react";
import { enablePush, pushPermission, type PushStatus } from "./push";

export function usePushSetting() {
  const [status, setStatus] = useState<PushStatus>("default");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setStatus(pushPermission());
  }, []);

  async function turnOn(): Promise<PushStatus> {
    setBusy(true);
    setError(null);
    try {
      const next = await enablePush();
      setStatus(next);
      return next;
    } catch {
      setError("Notifications are allowed, but this device could not be registered. Try again.");
      return status;
    } finally {
      setBusy(false);
    }
  }

  return { status, busy, error, turnOn };
}
